export default(state,storeState)=>{
    if (Object.keys(storeState).length) {
        for (const key in state) {
            state[key] = storeState[key]
        }
    }
}